import { api } from "./client.js";
import { DEMO_SQUAD } from "./mock.js";
const demo = import.meta.env.VITE_DEMO_MODE === "true";
let _demoSquad = { ...DEMO_SQUAD, units: DEMO_SQUAD.units.map(u => ({ ...u })) };
export const squadApi = {
    active: () => demo ? Promise.resolve(_demoSquad) : api.get("/squad"),
    getRules: () => api.get("/squad/rules"),
    setRules: (ruleIds) => api.post("/squad/rules", { ruleIds }),
    setPreset: (preset) => {
        if (demo) {
            _demoSquad = { ..._demoSquad, preset };
            return Promise.resolve({ preset });
        }
        return api.patch("/squad/preset", { preset });
    },
    setSlots: (slots) => api.patch("/squad/slots", { slots }),
    equipModule: (unitDefId, moduleId) => api.post("/squad/equip-module", { unitDefId, moduleId }),
    equipPerk: (unitDefId, perkId) => api.post("/squad/equip-perk", { unitDefId, perkId }),
    renameUnit: (unitDefId, nickname) => {
        if (demo) {
            const unit = _demoSquad.units.find(u => u.unitDefId === unitDefId);
            if (unit)
                unit.nickname = nickname;
            return Promise.resolve({ unitDefId, nickname });
        }
        return api.patch("/squad/rename-unit", { unitDefId, nickname });
    },
    upgrade: (unitDefId) => {
        if (demo) {
            const unit = _demoSquad.units.find(u => u.unitDefId === unitDefId);
            if (!unit || unit.level >= 5)
                return Promise.reject(new Error("Max level"));
            const cost = Math.floor(100 * Math.pow(1.5, unit.level - 1));
            unit.level += 1;
            // Scale stats by 8%
            unit.stats = Object.fromEntries(Object.entries(unit.stats).map(([k, v]) => [k, Math.round(v * 1.08)]));
            return Promise.resolve({ unitDefId, level: unit.level, cost, creditsLeft: 500 - cost, stats: unit.stats });
        }
        return api.post("/squad/upgrade", { unitDefId });
    },
};
